<template>

  <!-- Private coaching -->
  <div v-if="bill.coachingType === 'private_coaching'">
    <button
        v-if="bill.billingType === 'individuell' || bill.billingType === 'endabrechnung'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="printPrivateCoachingIndividualBill">
      <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
    </button>

    <button
        v-if="bill.billingType === 'pauschalabrechnung' && bill.firstBill === true"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="printPrivateCoachingPauschalFirstBill">
      <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
    </button>

    <button
        v-if="bill.billingType === 'pauschalabrechnung' && bill.firstBill === false"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="printPrivateCoachingPauschalFinalBill">
      <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
    </button>
  </div>

  <!-- Group coaching -->
  <div v-if="bill.coachingType === 'group_coaching'">
    <button
        v-if="bill.billingType === 'individuell'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="printGroupCoachingIndividualBill">
      <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
    </button>

    <button
        v-if="bill.billingType === 'einmalzahlung'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="printGroupCoachingOneTimePaymentBill">
      <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
    </button>
  </div>

  <!-- Socio therapy coaching -->
  <button
      v-if="bill.coachingType === 'socio_therapy_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printSocioTherapyCoachingIndividualBill">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
  </button>

  <!-- Assisted living coaching -->
  <div v-if="bill.coachingType === 'assisted_living_coaching'">
    <button
        v-if="bill.billingType === 'individual_private_payment'"
        class="btn btn-primary"
        :class="{ 'btn-padded': icon }"
        @click.prevent="printAssistedLivingCoachingIndividualBill">
      <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
    </button>
  </div>

  <!-- Private learning coaching -->
  <button
      v-if="bill.coachingType === 'private_learning_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printPrivateLearningCoachingBill">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
  </button>

  <!-- Case management coaching -->
  <button
      v-if="bill.coachingType === 'case_management_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printCaseManagementCoachingBill">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
  </button>

  <!-- Job coaching -->
  <button
      v-if="bill.coachingType === 'job_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printJobCoachingBill">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
  </button>

  <!-- Occupational therapy coaching -->
  <button
      v-if="bill.coachingType === 'occupational_therapy_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printOccupationalTherapyCoachingBill">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
  </button>

  <!-- Special case -->
  <button
      v-if="bill.coachingType === 'special_case'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="printSpecialCaseBill">
    <i v-if="icon" class="fa-solid fa-print me-1"></i>{{ $t('general.print') }}
  </button>


</template>

<script setup>
import {CloseToast} from '@/components/VueToast';
import {downloadFile} from '@/shared/functions';
import {defineProps} from 'vue';

const props = defineProps({
  bill: {
    type: Object,
    required: true,
  },
  icon: {
    type: Boolean,
    default: false,
  },
});

// PRIVATE COACHING
const printPrivateCoachingIndividualBill = () => {
  CloseToast();
  downloadFile(
      `/billing/private-coaching/individual-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};
const printPrivateCoachingPauschalFirstBill = () => {
  CloseToast();
  downloadFile(
      `/billing/private-coaching/pauschal-first-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};
const printPrivateCoachingPauschalFinalBill = () => {
  CloseToast();
  downloadFile(
      `/billing/private-coaching/pauschal-final-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};

// GROUP COACHING
const printGroupCoachingIndividualBill = () => {
  CloseToast();
  downloadFile(
      `/billing/group-coaching/individual-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};
const printGroupCoachingOneTimePaymentBill = () => {
  CloseToast();
  downloadFile(
      `/billing/group-coaching/one-time-payment-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};

// SOCIO THERAPY COACHING
const printSocioTherapyCoachingIndividualBill = () => {
  CloseToast();
  downloadFile(
      `/billing/socio-therapy-coaching/individual-type-print-bill/${props.bill.id}`,
      undefined, undefined,
  );
};

// ASSISTED LIVING COACHING
const printAssistedLivingCoachingIndividualBill = () => {
  CloseToast();
  downloadFile(
      `/billing/assisted-living-coaching/individual-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
}

// PRIVATE LEARNING COACHING
const printPrivateLearningCoachingBill = () => {
  CloseToast();
  downloadFile(
      `/billing/private-learning-coaching/final-settlement-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};

// CASE MANAGEMENT COACHING
const printCaseManagementCoachingBill = () => {
  CloseToast();
  downloadFile(
      `/billing/case-management-coaching/individual-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};

// JOB  COACHING
const printJobCoachingBill = () => {
  CloseToast();
  downloadFile(
      `/billing/job-coaching/individual-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};

// OCCUPATIONAL THERAPY  COACHING
const printOccupationalTherapyCoachingBill = () => {
  CloseToast();
  downloadFile(
      `/billing/occupational-therapy-coaching/individual-bill-print/${props.bill.id}`,
      undefined, undefined,
  );
};


// SPECIAL CASE
const printSpecialCaseBill = () => {
  CloseToast();
  downloadFile(
      `/billing/special-case/print-bill/${props.bill.id}`,
      undefined, undefined,
  );
};

</script>

<style scoped>
.btn-padded {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
